module.exports = __webpack_public_path__ + "static/media/grid-5.b5b500b1.svg";